<div class="main-page text-center">
  <app-header></app-header>
  @if (labelsDataService.labelsUnavailable && !isMaintenancePage) {
    <main class="subscription-unavailable">
      <section class="subscription-unavailable__message">
        <h1>Parcours de souscription momentanément indisponible</h1>
        <p>
          Une erreur technique est survenue. Merci de bien vouloir renouveler ultérieurement votre demande. En cas de
          besoin, nous vous invitons à contacter nos conseillers au 0 970 15 77 77 (appel non surtaxé) du lundi au
          vendredi de 9h à 19.
        </p>
      </section>
    </main>
  } @else {
    <div class="back-btn" *ngIf="isPrevPageExists">
      <div (click)="navigateToPrevPage()">
        <span class="mb-1 img-back" alt=""></span> <br />{{ 'HOME.PreviousPageText' | labelText }}
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-1 col-md-1 col-lg-11"></div>
        <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10 page-content centered-by-margin">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <div class="footer">
      <app-footer></app-footer>
      <div class="bottom-nav">
        <a *ngFor="let link of linksInTheFooter" href="javascript:void(0)" (click)="onFooterLinkClick(link)">
          {{ link.label }}
        </a>
      </div>
    </div>
  }
</div>
